"use client"

import { motion } from "framer-motion"

const logos = [
  { src: "/images/chat-upload-0.png", alt: "Blue Cross Blue Shield", href: "https://www.bcbs.com/" },
  { src: "/images/chat-upload-1.png", alt: "Aetna", href: "https://www.aetna.com/" },
  { src: "/images/chat-upload-2.png", alt: "Medicaid", href: "https://www.medicaid.gov/" },
]

const InsuranceSection = () => {
  return (
    <section id="insurance" className="section-padding bg-[hsl(var(--sage-light))]/30">
      <div className="max-w-5xl mx-auto text-center">

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-4 leading-snug">
            Care That Works with Your Insurance Providers
          </h2>
          <div className="w-14 h-0.5 bg-[hsl(var(--sage))] mx-auto mb-10" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="flex flex-wrap justify-center items-center gap-8 md:gap-14"
        >
          {logos.map((logo, i) => (
            <a
              key={i}
              href={logo.href}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-2xl shadow-sm border border-[hsl(var(--sage-light))] px-8 py-5 flex items-center justify-center hover:shadow-md hover:-translate-y-0.5 transition-all"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-20 w-auto object-contain"
                loading="lazy"
                decoding="async"
                width={200}
                height={80}
              />
            </a>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10"
        >
          <a
            href="/insurance"
            className="inline-flex items-center justify-center rounded-full bg-[hsl(var(--terracotta))] text-white px-9 py-3.5 text-base font-semibold hover:bg-[hsl(var(--terracotta))]/90 transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5"
          >
            See All Insurance Plans We Accept
          </a>
        </motion.div>

      </div>
    </section>
  )
}

export default InsuranceSection
